import { useCallback, useEffect, useState } from 'react';
import { userActivity } from 'venn-utils';

/**
 * Generic hook for persisting recent searches in local storage
 * @param CACHE_SIZE max number of recent searches to keep
 * @param storageKey key to use for local storage (e.g. userActivity.USER_LIBRARY_RECENT_QUERIES)
 */
export const useRecentLibrarySearches = (CACHE_SIZE: number, storageKey: string) => {
  const [recentSearches, setRecentSearches] = useState<string[]>([]);
  useEffect(() => {
    const storageParams = userActivity.getLocalStorageItemPerUser(storageKey);
    const queries = storageParams ? JSON.parse(storageParams) : [];
    setRecentSearches(queries);
  }, [storageKey]);

  const saveRecentSearch = useCallback(
    (query: string | undefined) => {
      if (!query || !query.trim()) {
        return;
      }
      const storageParams = userActivity.getLocalStorageItemPerUser(storageKey);
      let queries: string[] = storageParams ? JSON.parse(storageParams) : [];
      queries = queries.filter((q) => q && query.toLocaleLowerCase() !== q.toLocaleLowerCase());
      queries.unshift(query);
      queries = queries.slice(0, CACHE_SIZE);
      setRecentSearches(queries);
      userActivity.setLocalStorageItemPerUser(storageKey, JSON.stringify(queries));
    },
    [setRecentSearches, CACHE_SIZE, storageKey],
  );

  return {
    recentSearches,
    saveRecentSearch,
  };
};
